import { useEffect, useState } from "react";
import { Offcanvas, Tab, Tabs } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ESpinner from "components/others/Spinner";
import SolarIcon from "components/icons/SolarIcon";
import * as apiWarehouse from "api/apiWarehouses";
import OperationInfo from "./OperationInfo";
import TabPrice from "./tabs/TabPrice";

 
const OffOperationInfo = ({show, setShow}) => {

    const { t } = useTranslation(['Warehouses', 'Objects']);
    const [ operationInfo, setOperationInfo ] = useState(null);
    const [ activeTab, setActiveTab ] = useState('general');
 
    const fetchOperarion = async () => {
        
        const resOperation = await apiWarehouse.getOperationInfo(show);
        setOperationInfo(resOperation);
        console.log(resOperation)
    } 

    const handleHide = () =>{ 
        setShow(false);
        setTimeout(() => {
            setOperationInfo(null);
        }, 300);
    }

    useEffect(()=>{
        if (show) {
            setActiveTab('general');
            fetchOperarion();
        } else handleHide();
    },[show])

    return (<>
     
        <Offcanvas 
            show={show!==false} 
            onHide={handleHide}
            placement="end">
            <Offcanvas.Header closeButton className="border-bottom">
                <Offcanvas.Title>{t('titleOperInfo')}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="position-relative pb-0 d-flex flex-column px-0">
                {operationInfo
                    ? (
                        <div className="off-expend-team-tabs d-flex flex-column h-100">
                            <Tabs
                                variant="underline"
                                id="off-operation-info-tab"
                                className="b-3 invoice-tab border-bottom px-3"
                                activeKey={activeTab}
                                onSelect={(key) => key && setActiveTab(key)}
                            >
                                <Tab
                                    eventKey="general"
                                    title={
                                        <>
                                            <SolarIcon name="info-circle" className="me-2 fs-14" />
                                            {t('Objects:expendTeamWorkers.tabGeneral')}
                                        </>
                                    }
                                >
                                    <div className="off-create-team-content pt-3">
                                        <OperationInfo
                                            fetchOperarion={fetchOperarion}
                                            operationInfo={operationInfo}
                                        />
                                    </div>
                                </Tab>
                                <Tab
                                    eventKey="price"
                                    title={
                                        <>
                                            <SolarIcon name="currency-dollar" className="me-2 fs-14" />
                                            {t('Objects:changePriceSale.tab')}
                                        </>
                                    }
                                >
                                    <TabPrice
                                        operation={operationInfo.operation}
                                        onSaved={fetchOperarion}
                                    />
                                </Tab>
                            </Tabs>
                        </div>
                    )
                    : (<ESpinner/>)}
            </Offcanvas.Body>
        </Offcanvas>
        </>);
}

export default OffOperationInfo;